"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.execNpmCommand = void 0;
var npm_command_1 = require("./npm-command");
Object.defineProperty(exports, "execNpmCommand", { enumerable: true, get: function () { return npm_command_1.execNpmCommand; } });
//# sourceMappingURL=index.js.map